// @owners { team: patient-fulfillment }
import { createSelector } from 'reselect';
import { getNextAvailableDateAddressID } from './getNextAvailableDateAddressId';
import { getNextAvailableDateFacilityID } from './getNextAvailableDateFacilityId';
import { getNextAvailableDates } from './getNextAvailableDates';
import { TypescriptUtils } from '~shared/TypescriptUtils';
import { getScheduleablePrescriptions } from '~shared/features/my-meds/selectors/getScheduleablePrescriptions';
import { getNextAvailableDateID } from '~shared/features/next-available-date/helpers/getNextAvailableDateID';
import { type Prescription } from '~shared/types';

export const getNextAvailableDateIDsByScheduleablePrescriptionID = createSelector(
  [getNextAvailableDateAddressID, getNextAvailableDateFacilityID, getScheduleablePrescriptions],
  (addressID, facilityID: undefined | number, prescriptions: Prescription[]) => {
    const result: Record<number, string> = {};
    if (!(addressID || facilityID)) {
      return result;
    }
    prescriptions.forEach((prescription: Prescription) => {
      const nextAvailableDateID = getNextAvailableDateID({
        addressID,
        facilityID,
        prescriptionIDs: [prescription.id],
      });
      return (result[prescription.id] = nextAvailableDateID);
    });
    return result;
  },
);

export const getEarliestAvailableDatesByPrescriptionID = createSelector(
  [getNextAvailableDates, getNextAvailableDateIDsByScheduleablePrescriptionID],
  (nextAvailableDates, nextAvailableDateIDsByPrescriptionID) => {
    const result: Record<number, string> = {};
    TypescriptUtils.objectKeys(nextAvailableDateIDsByPrescriptionID).forEach((key) => {
      const nextAvailableDateID = nextAvailableDateIDsByPrescriptionID[key];
      const earliestAvailableDate = nextAvailableDates[nextAvailableDateID]?.earliest?.date || '';
      result[key] = earliestAvailableDate;
    });
    return result;
  },
);
